<h1 class="matp-page-title">デバイス情報一覧</h1>

<!-- タブ切替 -->
<div class="tw-flex tw-my-2 tw-items-center tw-justify-between">
  <mat-button-toggle-group
    class="matp-button-toggle-group matp-button-inactive"
    aria-label="表示種類"
    [hideSingleSelectionIndicator]="'true'"
    [(ngModel)]="selectedDisplayType"
    name="selectTab"
  >
    <mat-button-toggle class="tw-w-32" value="list">一覧表示</mat-button-toggle>
    <mat-button-toggle class="tw-w-32" value="map">地図表示</mat-button-toggle>
  </mat-button-toggle-group>

  <!-- エクスポート機能を実装するか顧客確認中のためコメントアウト中 -->
  <!-- @if (selectedDisplayType === "list") {
    <div class="tw-flex tw-justify-end">
      <button
        mat-raised-button
        id="export-btn"
        color="primary"
        (click)="exportToCsv()"
      >
        <mat-icon>Download</mat-icon>
        エクスポート
      </button>
    </div>
  } -->
</div>

@if (selectedDisplayType === "list") {
  <!-- デバイス情報一覧表示 -->
  <mat-card class="matp-card">
    <app-device-info-list-table
      [deviceList]="deviceList"
      [deviceTypes]="deviceTypes"
    ></app-device-info-list-table>
  </mat-card>
} @else {
  <!-- 地図表示 -->
  <app-device-info-map-container
    [deviceList]="deviceList"
    [deviceTypes]="deviceTypes"
  ></app-device-info-map-container>
}
